import React, { useEffect, useMemo, useState } from "react";
import PropTypes from 'prop-types';
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";

import {
  getCities as onGetCities,
  getPickUpPoints,
  getProBookings as onGetPreBookings,
  cancelOrder as cancelOrderAction,
  getToysGrouped as onGetToys,
  setPrebookingOrdersStartDate,
  setPrebookingOrdersEndDate
} from "store/actions";


//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
  Col,
  Row,
  Card,
  CardBody,
  Button,
  UncontrolledTooltip,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer, toast } from "react-toastify";
import OffCanvasComponent from "pages/Customers/OffCanvasComponent";
import { mkConfig, generateCsv, download } from "export-to-csv";
import { filterOrders } from "./Upcoming";
import { formatDate, formatDateWithDay } from "helpers/date_helper";
import moment from "moment";
import CancelOrderModal from "components/Common/CancelOrderModal";
import { get, post } from "helpers/api_helper";
import { CANCEL_ORDER_API } from "helpers/url_helper";
import RefundOrderModal from "components/Common/RefundOrderModal";
import EditOrderModal from "./EditOrder";

function PreBookings() {

  //meta title
  document.title = "Master >> PreBookings";
  const dispatch = useDispatch();
  const [limit, setLimit] = useState(10);
  const [query, setQuery] = useState("");
  const [city, setCity] = useState("All");
  const [pickUpType, setPickUpType] = useState("all");
  const [pickUpPoint,setpickUpPoint] = useState("all");

  const selectOrderState = (state) => state.Order;
  const OrderProperties = createSelector(
    selectOrderState,
    (Order) => ({
      preBookings: Order.preBookings,
      totalOrders: Order.totalOrders
    })
  );

  const selectPickUpPointState = (state) => state.PickupPoint;
  const PickupPointProperties = createSelector(
      selectPickUpPointState,
      (PickupPoint) => ({
          pickUpPoints: PickupPoint.pickUpPoints
      })
  );

  const selectDateState = (state) => state.OrderDates;
  const DateProperties = createSelector(
      selectDateState,
      (Dates) => ({
          _startDate: Dates.prebookingOrdersStartDate,
          _endDate: Dates.prebookingOrdersEndDate
      })
  );

  const { _startDate, _endDate } = useSelector(DateProperties);

  const [startDate, setStartDate] = useState(_startDate);
  const [endDate, setEndDate] = useState(_endDate);

  const { pickUpPoints } = useSelector(PickupPointProperties);
  
  const { preBookings,totalOrders } = useSelector(OrderProperties);

  const [isLoading, setLoading] = useState(true);
  const [week, setWeek] = useState(0);
  const [orders, setOrders] = useState([]);
  const [pageNumber, setPage] = useState(1);

  useEffect(() => {
    dispatch(getPickUpPoints());
  }, [dispatch]);

  useEffect(() => {
    dispatch(onGetPreBookings(pageNumber, limit, startDate, endDate, query, city, pickUpType, pickUpPoint));
  }, [dispatch,pageNumber, limit, startDate, endDate, query, city, pickUpType, pickUpPoint]);


  

  const [isCanvasOpen, setIsCanvasOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState({});

  const toggleCanvas = () => {
      setIsCanvasOpen(!isCanvasOpen);
  };

  const onOrderClick= (orderDetails) => {
      toggleCanvas();
      setSelectedOrder(orderDetails);
  }
 

  const csvConfig = mkConfig({ useKeysAsHeaders: true });

  const exportToCSVButtonClicked = async () => {
    try {

      const csvData = preBookings?.map((order) => {
        return {
          orderId: order?.orderId,
          customerName: order?.customer?.fname + " " + order?.customer?.lname,
          mobile: order?.customer?.mobile,
          toy_pic: order?.toy?.defaultPhoto,
          toy_name: order?.toy?.name,
          city: order?.customer?.city?.name,
          zone: order?.customer?.zone?.name ? order?.customer?.zone?.name : "Not Available",
          pincode: order?.customer?.pincode,
          orderDate: formatDate(order?.createdAt),
          deliveryDate: formatDate(order?.deliveryDate),
          returnDate: formatDate(order?.returnDate),
          orderTotal: order?.orderTotal,
          deliverCharge: order?.deliveryFee,
          duration: (order?.duration * 7) + " days",
          paid: order?.paid,
          selfPickup: order?.selfPickup ? "Yes" : "No",
        };
      });

      if(csvData.length === 0) {
        toast.error("No data to export");
        return;
      }

      const csv = generateCsv(csvConfig)(csvData);
      download(csvConfig)(csv)  
    } catch (error) {
      toast.error("Error in exporting data");
      console.log("Error in exporting data", error);
    }
  }

  const [cancelOrderModal, setCancelOrderModal] = useState(false);
  const [reason,setReason] = useState("");
  const [orderId, setOrderId] = useState("");

  const onClickCancelOrder = async (id) => {
      setCancelOrderModal(true);
      setOrderId(id);
  }      

  const cancelOrder = async () => {
    try {
      if(reason === "") {
        toast.error("Please enter reason to cancel order");
        return;
      }
        const res = await post(CANCEL_ORDER_API, {orderId, reason});
        toast.success("Order Cancelled Successfully");
        dispatch(onGetPreBookings(pageNumber, limit, startDate, endDate, query, city, pickUpType, pickUpPoint));
        setReason("");
        setCancelOrderModal(false);
    } catch (error) {
         let errorMessage = !error?.response ? "No internet connection. Please check your network settings and try again." : (error?.response?.data?.message || "Something went wrong");

        toast.error(errorMessage);
    }
  }

  const [refundOrderModal, setRefundOrderModal] = useState(false);
  const [refundData, setRefundData] = useState({});
  const onRefundColseClick = () => {
    setRefundOrderModal(false);
    setOrderId("");
  }

  const refundOrder = async (data) => {
    try {
      const res = await post(`/orders/refund/${orderId}`, data);
      toast.success("Order refunded successfully");
      dispatch(onGetPreBookings(pageNumber, limit, startDate, endDate, query, city, pickUpType, pickUpPoint));
      setRefundOrderModal(false);
      setOrderId("");
    } catch (error) {
      console.log(error);
      toast.error(`${error.response.data.message || "Something went wrong"}`);
    }
  }

  // Edit Order Functionality

  const [editOrderModal, setEditOrderModal] = useState(false);
  const [pickupPointSelected, setPickupPointSelected] = useState(false);
  const [pickupPoints, setPickupPoints] = useState([]);
  const [pickupPoint, setPickupPoint] = useState({
    _id: "",
    storeName: "",
    city: "",
    status: false
  });
  const [availabilityLoading, setAvailabilityLoading] = useState(false);
  const [availableDates, setAvailableDates] = useState({});
  const [deliveryDate, setDeliveryDate] = useState("");
  const [duration, setDuration] = useState(0);
  const [selectedToy, setSelectedToy] = useState({});
  const [selectedToyUnit, setSelectedToyUnit] = useState(null);
  const [toyError, setToyError] = useState("");

  const handleToyChange = (toy) => {
    setSelectedToy(toy);
    setSelectedToyUnit(null);
  };

  const closeEditModal = () => {
    setEditOrderModal(false);
    setSelectedOrder({});
    setSelectedToy({});
    setSelectedToyUnit(null);
  };


  // Fetch Toys
  const selectToyState = (state) => state.Toy;
  const ToyProperties = createSelector(
    selectToyState,
    (Toy) => ({
      toys: Toy.toys,
    })
  );
  const { toys } = useSelector(ToyProperties);
  useEffect(() => {
    dispatch(onGetToys(1, 1000, "", "all", "all", "all", "all", "all"));
  }, [dispatch]);

  // Fetch PickUp Points
  const fetchPickUpPoints = async () => {
    try {
      const res = await get(`orders/pickup-points/${selectedOrder?.customer?._id}`);
      setPickupPoints(res?.pickUpPoints);
    } catch (error) {
      console.log("Error in fetching pick up points", error);
    }
  }

  // Get Availibility Dates
  const getAvailibility = async (deliveryDate, duration, orderId, toyId, pickupPointSelected, toyUnitId) => {
    setAvailabilityLoading(true);
    setToyError("")
    try {
      let _deliveryDate = deliveryDate ? new Date(deliveryDate).toISOString() : selectedOrder?.deliveryDate;
      const res = await post(`orders/check-toy-availability/${toyId}`, {orderId, deliveryDate: _deliveryDate, duration, selfPickup: pickupPointSelected, toyUnitId});
      console.log(res);
      setAvailableDates(res?.availability);
      setDeliveryDate(moment(deliveryDate).format("YYYY-MM-DD"));
    } catch (error) {
      setAvailableDates(error?.response?.data?.availability);
      console.log("Error in getting availibility", error);
      setDeliveryDate("");
      let message = error?.response?.data?.message || "Error in getting availibility";
      setToyError(message);
    }
    setAvailabilityLoading(false);
  }

  useEffect(() => {
    if(selectedToy?._id){
      getAvailibility(deliveryDate, duration, selectedOrder?._id, selectedToy?._id, pickupPointSelected, selectedToyUnit?.value);
    }
  }, [selectedToy, selectedOrder, pickupPointSelected, selectedToyUnit]);

  useEffect(() => {
    if(selectedOrder?.customer?._id !== undefined){
      fetchPickUpPoints();
    }
  }, [selectedOrder?.customer?._id]);

  // Save Edited Order
  const saveOrder = async () => {
    try{
      if(!selectedToyUnit?.value){
        toast.error("Please select a toy unit");
        return;
      }
      if(!deliveryDate){
        toast.error("Please select a delivery date");
        return;
      }
      if (moment(selectedOrder.deliveryDate).format('YYYY-MM-DD') !== moment(deliveryDate).format('YYYY-MM-DD')) {
        if (availableDates && availableDates["w" + duration]?.includes(deliveryDate) === false) {
          toast.error(`Toy is not available for selected duration on ${formatDateWithDay(deliveryDate)}`);
          return;
        }
      }
      if(pickupPointSelected && !pickupPoint?._id){
        toast.error("Please select a pickup point");
        return;
      }
      const res = await post(`/orders/edit-order/${selectedOrder?._id}`, {toyId: selectedToyUnit.value, deliveryDate, duration, pickupPoint: pickupPointSelected ? pickupPoint : null});
      setEditOrderModal(false);
      setSelectedOrder({});
      setSelectedToy({});
      setSelectedToyUnit(null);
      toast.success("Order updated successfully");
      dispatch(onGetPreBookings(pageNumber, limit, startDate, endDate, query, city, pickUpType, pickUpPoint));
    }
    catch(error){
      setEditOrderModal(false);
      setSelectedOrder({});
      setSelectedToy({});
      setSelectedToyUnit(null);
      console.log("Error in editing order", error);
      let message = error?.response?.data?.message || "Error in editing order";
      toast.error(message);
    }
  }

  const selectCityState = (state) => state.City;
  const CityProperties = createSelector(
    selectCityState,
    (City) => ({
      cities: City.cities
    })
  );

  const { cities } = useSelector(CityProperties);

  useEffect(() => {
    dispatch(onGetCities());
  }, [dispatch]);
  
  const columns = useMemo(
    () => [
      {
        Header: 'Order ID',
        accessor: "orderId",
        width: "150px",
        style: {
            textAlign: "center",
            width: "10%",
            background: "#0000",
        },
        filterable: true,
        Cell: ({ row }) => {
            return <>{row?.original?.orderId ?? " "} </>;
        },
      },
      {
        Header: 'Customer Name',
        accessor: 'name',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
            {cellProps?.row?.original?.customer?.fname?.charAt(0).toUpperCase() + cellProps?.row?.original?.customer?.fname?.slice(1) + " " + cellProps?.row?.original?.customer?.lname?.charAt(0).toUpperCase() + cellProps?.row?.original?.customer?.lname?.slice(1)}
          </>;
        }
      },
      {
        Header: 'Mobile',
        accessor: 'mobile',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
            {cellProps?.row?.original?.customer?.mobile}
          </>;
        }
      },
      {
        Header: 'Toy Pic',
        accessor: 'toy_pic',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
            <img src={cellProps?.row?.original?.toy?.defaultPhoto} alt="toyImage" className="avatar-sm"/>          </>;
        }
      },
      {
        Header: 'Toy Name',
        accessor: 'toy_name',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
            {cellProps?.row?.original?.toy?.name}
          </>;
        }
      },
      {
        Header: 'City',
        accessor: 'city',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
            {cellProps?.row?.original?.customer?.city?.name}
          </>;
        }
      },
      {
        Header: 'Zone',
        accessor: 'zone',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
            {cellProps?.row?.original?.customer?.zone?.name ? cellProps?.row?.original?.customer?.zone?.name : "Not Available"}
          </>;
        }
      },
      {
        Header: 'Pin Code',
        accessor: 'pincode',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
            {cellProps?.row?.original?.customer?.pincode}
          </>;
        }
      },
      {
        Header: 'Delivery Date',
        accessor: 'deliveryDate',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
            {formatDate(cellProps?.row?.original?.deliveryDate)}
          </>;
        }
      },
      {
        Header: 'Return Date',
        accessor: 'returnDate',
        width: '150px',
        style: {
          textAlign: "center",
          width: "10%",
          background: "#0000",
        },
        filterable: true,
        Cell: (cellProps) => {
          return <>
            {formatDate(cellProps?.row?.original?.returnDate)}
          </>;
        }
      },
      {
        Header: "Action",
        accessor: "action",
        width: "150px",
        style: {
            textAlign: "center",
            width: "10%",
            background: "#0000",
        },
        filterable: true,
        Cell: ({ row }) => {
            
            return (
              <div className="d-flex gap-3">
                <div className="text-primary" onClick={() => onOrderClick(row?.original)} style={{ cursor: "pointer"}}>
                  <i className="mdi mdi-eye font-size-18" id="eyetooltip" />
                  <UncontrolledTooltip placement="top" target="eyetooltip">
                    Order Details
                  </UncontrolledTooltip>
                </div>
                <div className="text-success" style={{ cursor: "pointer"}} onClick={() => {
                  setEditOrderModal(true)
                  setSelectedOrder(row?.original)
                  const groupedToy = toys.find(t => t.variants?.some(v => v._id === row?.original?.toy?._id)) || toys.find(t => t._id === row?.original?.toy?._id) || row?.original?.toy;
                  setSelectedToy(groupedToy);
                  const matchedUnit = groupedToy?.variants?.find(v => v._id === row?.original?.toy?._id) || row?.original?.toy;
                  setSelectedToyUnit(matchedUnit ? { value: matchedUnit._id, label: matchedUnit.code, unit: matchedUnit } : null);
                  setDuration(parseInt(row?.original?.duration))
                  setPickupPointSelected(row?.original?.selfPickup ? true : false)
                  setPickupPoint(row?.original?.selfPickup ? row?.original?.selfPickup : "")
                  setDeliveryDate(row?.original?.deliveryDate)
                  getAvailibility(row?.original?.deliveryDate, row?.original?.duration, row?.original?._id, groupedToy?._id || row?.original?.toy?._id, row?.original?.selfPickup ? true : false, row?.original?.toy?._id)
                }}>
                  <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    Edit Order
                  </UncontrolledTooltip>
                </div>
              </div>
            );
        }
      },
      {
        // Column for the cancel order button
        Header: "Refund / Cancel Order",
        accessor: "cancelOrder",
        width: "150px",
        style: {
            textAlign: "center",
            width: "10%",
            background: "#0000",
        },
        filterable: true,
        Cell: ({ row }) => {
            return (
                <Button
                    color="danger"
                    onClick={() =>  {
                      setOrderId(row?.original?._id);
                      setRefundOrderModal(true);
                      setRefundData({
                        orderId: row?.original?.orderId,
                        customerName: row?.original?.customer?.fname + " " + row?.original?.customer?.lname,
                        toyName: row?.original?.toy?.name,
                      })
                    }}
                >
                    Cancel
                </Button>
            );
        }
      }
    ],
    []
  );

  return (
    <React.Fragment>

    <CancelOrderModal
      show={cancelOrderModal}
      onCancelClick={() => cancelOrder()}
      onCloseClick={() => setCancelOrderModal(false)}
      setReason={setReason}
    />
    <RefundOrderModal 
          show={refundOrderModal}
          onCloseClick={onRefundColseClick}
          onRefundClick={refundOrder}
          data={refundData}
    />

    <EditOrderModal
      show={editOrderModal}
      onCloseClick={closeEditModal}
      selectedOrder={selectedOrder}
      toys={toys}
      duration={duration}
      setDuration={setDuration}
      pickupPointSelected={pickupPointSelected}
      toyError={toyError}
      saveOrder={saveOrder}
      availabilityLoading={availabilityLoading}
      selectedToy={selectedToy}
      setPickupPointSelected={setPickupPointSelected}
      setPickupPoint={setPickupPoint}
      availableDates={availableDates}
      setToyError={setToyError}
      pickupPoints={pickupPoints}
      pickupPoint={pickupPoint}
      setDeliveryDate={setDeliveryDate}
      deliveryDate={deliveryDate}
      setSelectedToy={setSelectedToy}
      selectedToyUnit={selectedToyUnit}
      setSelectedToyUnit={setSelectedToyUnit}
      handleToyChange={handleToyChange}
    />

      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Home" breadcrumbItem="Pre Booking" />
            <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    <TableContainer
                      columns={columns}
                      data={preBookings}
                      // isGlobalFilter={true}
                      isCustomGlobalFilter={true}
                      setQuery={setQuery}
                      handleOrderClicks={() => {}}
                      customPageSize={10}
                      isPagination={false}
                      filterable={false}
                      isStartDate={true}
                      startDate={startDate}
                      setStartDate={(date) => {
                        setStartDate(date);
                        dispatch(setPrebookingOrdersStartDate(date));
                      }}
                      isEndDate={true}
                      endDate={endDate}
                      setEndDate={(date) => {
                        setEndDate(date);
                        dispatch(setPrebookingOrdersEndDate(date));
                      }}
                      DateFilterTitle={"Delivery Date"}
                      csvExport={true}
                      exportToCSVButtonClicked={exportToCSVButtonClicked}
                      setWeek={setWeek}
                      isPickUpPointOptions={true}
                      isCityFilter={true}
                      cities={cities}
                      city={city}
                      setCity={setCity}
                      pickUpType={pickUpType}
                      setPickUpType={setPickUpType}
                      pickUpPoints={pickUpPoints}
                      setpickUpPoint={setpickUpPoint}
                      pickUpPoint={pickUpPoint}
                      iscustomPageSizeOptions={true}
                      tableClass="align-middle table-check"
                      theadClass="table-light"
                      pagination="pagination pagination-rounded justify-content-end mb-2"
                      isCustomPagination={true}
                      setPage={setPage}
                      pageNumber={pageNumber}
                      totals={totalOrders}
                      setLimit={setLimit}
                    />
                    
                  </CardBody>
                </Card>
              </Col>
            </Row>
        </div>
      </div>
      <ToastContainer />
      <OffCanvasComponent
        isCanvasOpen={isCanvasOpen}
        toggleCanvas={toggleCanvas}
        selectedOrder={selectedOrder} 
      />
    </React.Fragment>
  );
}
PreBookings.propTypes = {
  preGlobalFilteredRows: PropTypes.any,

};


export default PreBookings;